import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome, faBagShopping, faCartShopping, faBasketShopping,
  faPlusCircle, faCaretDown, faCaretRight, faDashboard, faGear, faCoins,faRectangleList,faCaretLeft,
  faSignOut, faUser
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from './context/themecontext';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
}

const MSidebar = ({ isOpen, toggleSidebar }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [Sales, setSales] = useState(false);
  const [Settings, setSettings] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const roleId = parseInt(sessionStorage.getItem('roleId'), 10);

  // useEffect(() => {
  //   setIsCollapsed(isMobile);
  // }, [isMobile]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
  if (isMobile) {
    setIsCollapsed(false); // always expanded on mobile
  } else {
    setIsCollapsed(false); // default collapsed on desktop
  }
}, [isMobile]);


  const shouldShowMenuItem = (menuItem) => {
    switch (roleId) {
      case 7:
        return true; // All menu items visible
      default:
        return menuItem === 'Home'; // For any other roleId, show only Home
    }
  };

  const menu = {
    Home: 1, Profile: 2, Settings: 3, Logout: 4,
  };

  const handleMenuClick = (menu, submenu) => {
    if (isMobile) {
      toggleSidebar(); // Close sidebar on mobile
    }

    // Navigation logic based on menu and submenu
    if (menu === 1) {
      navigate('/mfr/app/mdc');
    } else if (menu === 2) {
      navigate('/mfr/app/profile')
    } else if (menu === 3) {
      navigate('/mfr/app/settings')
    } else if (menu === 4) {
      // Add your submenu navigation logic here
    } else if (menu === 5) {
      // Add your submenu navigation logic here
    } else if (menu === 6) {
      // Add your submenu navigation logic here
    } else if (menu === 7) {
      // Add your submenu navigation logic here
    } else if (menu === 8) {
      // Add your submenu navigation logic here
    }
  };

    const handleLogout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}vendor/vendor-logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': sessionStorage.getItem('token')
        }
      });
  
      const data = await response.json();
  
      if (response.ok) {
        localStorage.clear();
        sessionStorage.clear();
        toggleSidebar();


        navigate('/mfr');
      } else if (response.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        toggleSidebar();


        navigate('/mfr');
            }else {
        console.error('Logout failed:', data.message);
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
<div
  className={`flex flex-col text-[0.8125rem] font-normal z-[999] transition-colors duration-300
    ${isMobile
      ? (isOpen 
          ? 'fixed top-[3rem] right-0 w-[30%] h-[40%] shadow-lg rounded-l-lg' 
          : 'hidden') 
      : (isCollapsed ? 'w-[3.5rem]' : 'w-[12.5rem]')}
    ${isDarkMode ? 'bg-gray-800 border-l border-gray-700 text-gray-100' : 'bg-white border-l border-gray-200 text-[#181C2E]'}`}
>
      <div className={`flex flex-col flex-1 w-full rounded-md`}>
        <div className="flex-grow">
          <ul className={`flex flex-col space-y-3 px-2 list-none h-full mt-4 ${isDarkMode ? 'text-gray-100' : 'text-[#181C2E]'}`}>
            {shouldShowMenuItem('Home') && (
              <li onClick={() => handleMenuClick(menu.Home)}
                  className={`flex flex-row space-x-3 items-center py-2 rounded-l-md cursor-pointer transition-colors duration-200 ${location.pathname.includes('/mdc') ? isDarkMode ? 'bg-gray-700 text-[#f7525A]' : 'bg-[#EDEDF7] text-[#f7525A]' : isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-[#EDEDF7]'}`}>
                <FontAwesomeIcon icon={faHome} className="ml-2 mr-2" />
                {!isCollapsed && <span>Home</span>}
              </li>
            )}
             {shouldShowMenuItem('Profile') && (
              <li className={`flex flex-row space-x-3 items-center py-2 rounded-l-md cursor-pointer transition-colors duration-200 ${location.pathname.includes('/profile') ? isDarkMode ? 'bg-gray-700 text-[#f7525A]' : 'bg-[#EDEDF7] text-[#f7525A]' : isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-[#EDEDF7]'}`}
                  onClick={() => handleMenuClick(menu.Profile)}>
                <FontAwesomeIcon icon={faUser} className="ml-2 mr-2" />
                {!isCollapsed && <span>Profile</span>}
              </li>
            )}

            {shouldShowMenuItem('Settings') && (
              <li className={`flex flex-row space-x-3 items-center py-2 rounded-l-md cursor-pointer transition-colors duration-200 ${location.pathname.includes('/settings') ? isDarkMode ? 'bg-gray-700 text-[#f7525A]' : 'bg-[#EDEDF7] text-[#f7525A]' : isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-[#EDEDF7]'}`}
                  onClick={() => handleMenuClick(menu.Settings)}>
                <FontAwesomeIcon icon={faGear} className="ml-2 mr-2" />
                {!isCollapsed && <span>Settings</span>}
              </li>
            )}
          </ul>
        </div>
      </div>

    {/*   {isMobile && isOpen && ( */}
  <ul className={`flex flex-col space-x-3 px-2 list-none ${isDarkMode ? 'text-gray-100' : 'text-[#181C2E]'}`}>
    <li
      onClick={() => handleLogout()}
      className={`flex flex-row space-x-3 items-center py-2 rounded-l-md cursor-pointer font-semibold transition-colors duration-200 ${isDarkMode ? 'hover:bg-gray-700 text-red-400' : 'hover:bg-[#EDEDF7] text-[#f7525A]'}`}
    >
      <FontAwesomeIcon icon={faSignOut} className="ml-2 mr-2" />
      <span>Logout</span>
    </li>
  </ul>
{/* )} */}

{!isMobile && (
  <div
    className={`flex justify-center h-[2rem] items-center cursor-pointer border transition-colors duration-200 ${isDarkMode ? 'bg-gray-700 border-gray-600 text-gray-100' : 'bg-white border-gray-200'}`}
    onClick={toggleCollapse}
  >
    {isCollapsed ? <FontAwesomeIcon icon={faCaretRight} /> : <FontAwesomeIcon icon={faCaretLeft} />}
  </div>
)}


    </div>
  );
};

export default MSidebar;
